export default __webpack_public_path__ + "static/pana-b676475e0dfc547d8ad54238cce3a81f.png";